<template>
  <div>
    <Card
      title="Channel List"
    >
      <template v-slot:body>
        <div>
          <div class="pb-6 flex justify-between items-center">
            <div class="flex items-center">
              <div class="mr-2">
                <el-input placeholder="search channel name" v-model="filter.q" @change="searchChannel" ></el-input>
              </div>
              <Button @clicked="searchChannel" label="Apply"/>
              <button class="p-2" ><font-awesome-icon :icon="['fas', 'sync']" @click="resetChannel" /></button>
            </div>
            <Button @clicked="add" label="Add Channel" variant="outline-primary"/>
          </div>
        </div>

        <data-tables-server ref="tableChannel" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [displayingItem] }" @query-change="onChangeTable" >
          <el-table-column v-for="title in titles" :prop="title.prop.field" :label="title.label" :key="title.prop.field" sortable="custom">
          </el-table-column>
          <el-table-column label="Actions" align="right" min-width="100px">
            <template slot-scope="scope">
              <div class="static inline-block text-left container-action">
                <VueCustomTooltip label="See Detail" :position="'is-left'">
                  <a  :href="`/#/missions-videos/channel-detail/${scope.row.id}`" class="inline-block p-2 w-8 mb-2 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'eye']" />
                  </a>
                </VueCustomTooltip>
                <VueCustomTooltip label="Edit" :position="'is-left'">
                  <button @click="edit(scope.row)" class="p-2 w-8 mr-2 mb-2 rounded bg-green-400 hover:bg-green-500 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'pencil-alt']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip label="Delete" :position="'is-left'">
                  <button @click="deleteChannel(scope.row)" class="w-8 mr-2 mb-2 p-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                  </button>
                </VueCustomTooltip>
              </div>
            </template>
          </el-table-column>
        </data-tables-server>
      </template>
    </Card>
    <ModalDialog
      ref="addSong"
      :isShowingModal="isShowingModalForm"
      :title="titleModal"
      @toggleModal="isShowingModalForm = !isShowingModalForm"
      :labelSubmit="'Submit'"
      @save="submitFormChannel()" >
      <template slot="body" >
        <ChannelForm
          ref="channelForm"
          :toggle-reset="isShowingModalForm"
          :channel="selectedRow"
          @on-submit-channel="onSubmitForm"
        />
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import ModalDialogDetail from '@/components/Common/ModalDialogDetail';
import ModalDialog from '@/components/Common/ModalDialog';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import moment from 'moment';
import ChannelForm from '@/views/MissionsVideos/Channel/ChannelForm';
import Card from '@/components/Layout/Card';
import { Button } from '@/components/Layout/Form';

const initialStateChannel = {
  id: null,
  name: '',
  email: '',
  description: '',
  country_code: null,
  avatar: null,
  background_image: null,
};

export default {
  name: 'ChannelListPage',
  data() {
    return {
      isShowingModalForm: false,
      typeModal: 'add',
      utc_offset: Math.floor(moment().utcOffset() / 60),
      data: [],
      total: 0,
      displayingItem: 20,
      titles: [{
        prop: {
          field: 'name',
        },
        label: 'Channel Name',
      }, {
        prop: {
          field: 'email',
        },
        label: 'Channel Email',
      }, {
        prop: {
          field: 'created_at',
        },
        label: 'Registration Date',
      }],
      filter: {
        per_page: 20,
        q: '',
        sortorder: 'desc',
        sortby: 'id',
        page: 1,
      },
      selectedRow: { ...initialStateChannel },
    };
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListCountry();
    await this.requestListChannel(this.filter);
  },
  computed: {
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin', 'isOps', 'isFinance']),
    ...mapGetters('MissionsVideosModule', ['listChannel', 'totalListChannel']),
    titleModal() {
      return this.typeModal === 'add' ? 'Add Channel' : 'Edit Channel';
    },
  },
  watch: {
    listChannel: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        await this.refineData();
      },
    },
  },
  methods: {
    ...mapActions('MissionsVideosModule', ['requestListChannel', 'requestAddChannel',
      'requestEditChannel', 'requestDeleteChannel', 'requestDetailChannel']),
    ...mapActions('AppSettingModule', ['requestListCountry']),
    async searchChannel() {
      await this.requestListChannel(this.filter);
    },
    async resetChannel() {
      this.$refs.tableChannel.$refs.elTable.clearSort();
      this.filter = {
        per_page: 20,
        q: '',
        sortorder: 'desc',
        sortby: 'id',
        page: 1,
      };
      this.searchChannel();
    },
    refineData() {
      if (this.listChannel) {
        this.total = this.totalListChannel;
        this.data = this.listChannel.map(channel => ({ ...channel, created_at: moment(channel.created_at).format('YYYY-MM-DD HH:mm:ss') }));
      }
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filter.sortorder = sortorder;
      this.filter.sortby = sortby;
      this.filter.page = page;
      await this.requestListChannel(this.filter);
    },
    add() {
      this.selectedRow = { ...initialStateChannel };
      this.typeModal = 'add';
      this.isShowingModalForm = true;
    },
    edit(row) {
      this.selectedRow = { ...initialStateChannel,...row };
      this.typeModal = 'edit';
      this.isShowingModalForm = true;
    },
    deleteChannel(row) {
      Vue.swal({
        title: 'Delete Data!',
        text: `Are you sure to delete channel: ${row.name}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await this.requestDeleteChannel({
            data: {
              id: row.id,
            },
            filter: this.filter,
          });
          this.$swal('Deleted', `You successfully delete channel: ${row.name}`, 'success');
        }
      });
    },
    async onSubmitForm() {
      this.isShowingModalForm = false;
      await this.searchChannel();
    },
    async submitFormChannel() {
      await this.$refs.channelForm.submit();
    },
  },
  components: {
    ChannelForm,
    ModalDialogDetail,
    ModalDialog,
    VueCustomTooltip,
    Card,
    Button,
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/MissionsVideos/Channel/ChannelList.vue